import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/**
 * Renders child routes only for super_admin users.
 * All other roles are redirected to /dashboard.
 */
export default function AdminRoute() {
  const { user } = useAuth()
  if (user?.role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />
  }
  return <Outlet />
}
